import React from 'react';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { Container, Icon, Spinner, Stack, styled, Text } from 'bumbag';
import type { ReactElement } from 'react';

import Page from './Page';
const LoadingSpinner = styled(Spinner)`
  & svg {
    font-size: 60px;
  }
`;
type Props = {
  after?: ReactElement;
  before?: ReactElement;
  title?: string;
  state?: 'loading' | 'success';
};
FinishPage.defaultProps = {
  after: null,
  before: null,
  title: undefined,
  state: undefined,
};
export default function FinishPage(props: Props) {
  const { after, before, state, title } = props;
  return (
    <Page title={title}>
      <Container breakpoint="mobile" paddingTop="major-6" paddingBottom="major-6">
        <Stack spacing="major-2">
          {before}
          <div className="flex justify-center text-center">
            {state === 'loading' && <LoadingSpinner fontSize="900" />}
            {/* @ts-expect-error TS(2322): Type 'IconDefinition' is not assignable to type 's... Remove this comment to see the full error message */}
            {state === 'success' && <Icon fontSize="800" icon={faCheckCircle} type="font-awesome" />}
          </div>
          <div className="flex justify-center text-center">
            {state === 'loading' && (
              <Text fontSize="400" role="alert">
                Processing...
              </Text>
            )}
            {state === 'success' && (
              <Text fontSize="400" role="alert">
                Approved
              </Text>
            )}
          </div>
          {after}
        </Stack>
      </Container>
    </Page>
  );
}
